import { HeadersWithoutIterator } from '../types/HeadersWithoutIterator';

export function setHeaders(
    headers: HeadersWithoutIterator,
    headerVals: { [headerName: string]: string }
) {
    Object.keys(headerVals).forEach(headerName => headers.set(headerName, headerVals[headerName]));
}
